import { TopNav, Hero } from "@/components/Shared";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export default function Landing() {
  const { user, ready } = useAuth();
  if (ready && user) return <Navigate to="/dashboard" replace />;
  return (
    <div>
      <TopNav />
      <Hero />
      <footer className="border-t border-white/5 py-8 mt-10">
        <div className="max-w-7xl mx-auto px-4 text-center text-xs text-slate-500">
          AstaFantaLive • Strumento professionale per l'asta del fantacalcio
        </div>
      </footer>
    </div>
  );
}
